import {afterNextRender, AfterViewInit, Component, inject, Input, OnDestroy} from '@angular/core';
import {MatProgressSpinner} from '@angular/material/progress-spinner';
import {DomSanitizer} from '@angular/platform-browser';
import {environment} from '../../../environments/environment';
import {brand} from '../../settings/marqueblanche';
import {FuseSidebarService} from 'fuse-core/components/sidebar/sidebar.service';

@Component({
    selector: 'app-iackathon-wrapper',
    imports: [
        MatProgressSpinner
    ],
    templateUrl: './iackathon-wrapper.component.html',
    styleUrl: './iackathon-wrapper.component.scss',
})
export class IackathonWrapperComponent implements AfterViewInit, OnDestroy {
    private sanitizer = inject(DomSanitizer);
    @Input('autoFold') autoFold = false;
    private readonly token = localStorage.getItem('http_accessToken');
    protected url = this.sanitizer.bypassSecurityTrustResourceUrl(`${environment.iackathonUrl(brand)}?token=${this.token.slice(1, -1)}`);

    private fuseSidebarService = inject(FuseSidebarService);

    constructor() {
    }

    ngAfterViewInit(): void {
        if (this.autoFold) {
            this.fuseSidebarService.getSidebar('navbar')?.fold();
        }
    }

    ngOnDestroy(): void {
        if (this.autoFold) {
            this.fuseSidebarService.getSidebar('navbar')?.unfold();
        }

    }

}
